var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MainContent,{attrs:{"title":"Crear equipo"}},[_c(_setup.Card,[_c(_setup.FormEquipo,{attrs:{"lista-id":_setup.listaId,"saving":_setup.saving,"representantes":_setup.representantes,"representantes-loading":_setup.loading},on:{"terminado":_setup.crearEquipo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }